import { render, staticRenderFns } from "./user-add.vue?vue&type=template&id=d40aa984&scoped=true"
import script from "./user-add.vue?vue&type=script&lang=js"
export * from "./user-add.vue?vue&type=script&lang=js"
import style0 from "./user-add.vue?vue&type=style&index=0&id=d40aa984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40aa984",
  null
  
)

export default component.exports